import { useState } from 'react'
import { TbSettings } from 'react-icons/tb'

import { Button } from '@/Core/UI/Button'

import { TableSettingsDrawer } from './TableSettingsDrawer'

interface TableSettingsButtonProps {
    crudContext: any
}

/**
 * Кнопка налаштувань відображення в toolbar + власний Drawer.
 * Self-contained: тримає стан відкриття локально (як InvitationUserDrawer).
 */
export const TableSettingsButton = ({ crudContext }: TableSettingsButtonProps) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button type="link" onClick={() => setOpen(true)} icon={<TbSettings style={{ fontSize: 24 }} />} />
            <TableSettingsDrawer crudContext={crudContext} open={open} onClose={() => setOpen(false)} />
        </>
    )
}
